module.exports = __webpack_public_path__ + "user_info.5918591571a1aa4676953a9233b33e83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/user_info.svg
// module id = 357
// module chunks = 0